module.exports = __webpack_public_path__ + "static/media/start_selling_page_freelancer.5ad8cc24.webp";